<template>
  <ul
    v-if="items.length > 0"
    class="flex flex-row gap-4 text-secondary text-xl xl:text-3xl"
  >
    <li
      v-for="item in items"
      :key="item.id"
    >
      <a
        :href="item.url"
        rel="noopener"
        target="_blank"
        :title="item.type"
      >
        <font-awesome-icon
          v-if="iconLookupByType[item.type] !== undefined"
          :icon="iconLookupByType[item.type]"
        />
        <font-awesome-icon
          v-else
          :icon="['fas', 'link']"
        />
      </a>
    </li>
  </ul>
</template>

<script>
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faSnapchat } from '@fortawesome/free-brands-svg-icons/faSnapchat';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYelp } from '@fortawesome/free-brands-svg-icons/faYelp';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
  name: 'UrlList',

  props: {
    items: {
      required: true,
      type: Array,
    },
  },

  data() {
    return {
      iconLookupByType: {
        Facebook: [
          'fab',
          'facebook',
        ],
        Instagram: [
          'fab',
          'instagram',
        ],
        LinkedIn: [
          'fab',
          'linkedin',
        ],
        Snapchat: [
          'fab',
          'snapchat',
        ],
        Twitter: [
          'fab',
          'twitter',
        ],
        Yelp: [
          'fab',
          'yelp',
        ],
        YouTube: [
          'fab',
          'youtube',
        ],
      },
    };
  },

  created() {
    library.add(faFacebook);
    library.add(faInstagram);
    library.add(faLink);
    library.add(faLinkedin);
    library.add(faSnapchat);
    library.add(faTwitter);
    library.add(faYelp);
    library.add(faYoutube);
  },
};
</script>
